import OnboardingSlide from './OnboardingSlide';
import HandoverDemoAnimation from './HandoverDemoAnimation';

export default function SlideHandover() {
  return (
    <OnboardingSlide illustration={<HandoverDemoAnimation />} title="Shift Handover">
      <p>
        At the end of your shift, generate a <strong>handover report</strong> for the incoming nurse.
      </p>
      <ol className="list-inside list-decimal space-y-1 text-xs">
        <li>
          Open your <strong>profile</strong> and tap <strong>End Shift</strong>.
        </li>
        <li>Sawtna compiles an SBAR handover for each patient from your shift notes and tasks.</li>
        <li>Review each patient card — edit sections or outstanding tasks if needed.</li>
        <li>
          <strong>Download PDF</strong> to print, or <strong>Submit</strong> to save to Reports.
        </li>
      </ol>
      <p>
        You can also record a <strong>voice handover</strong> for individual patients during the shift
        — Sawtna detects handover speech and formats it as SBAR.
      </p>
    </OnboardingSlide>
  );
}
